import { create} from "zustand"
import IContextDocument from "../model/document/IContextDocument";

interface DocumentsState
{
    documents: IContextDocument[],
    activeDocumentIndex: number, // Optional: to track the active document
    getActiveDocument: () => IContextDocument | undefined,
    setActiveDocument: (doc: IContextDocument) => void, // Optional: to set the active document 
    setDocuments: (documents: IContextDocument[]) => void, // Optional: to set the documents array
    renameDocument: (doc: IContextDocument, newName: string) => void, // Optional: to rename a document
}

export const useDocumentsStateStore = create<DocumentsState>()(
    (set, get) => ({
        documents: [],
        activeDocumentIndex: -1, 
        getActiveDocument: () : IContextDocument | undefined => {
            const documents = get().documents;
            if (documents.length <= get().activeDocumentIndex) {
                return undefined;
            }
            return documents[get().activeDocumentIndex]; // Return the first document as the active one
        },
        setActiveDocument: (doc: IContextDocument) => {
            const documents = get().documents;
            const index = documents.indexOf(doc);
            if (index === -1) {
                throw new Error("Document not found in the store");
            }
            set({ activeDocumentIndex: index });
        },
        setDocuments: (documents: IContextDocument[]) => {
            if (!Array.isArray(documents)) {
                throw new Error("Documents must be an array");
            }

            set({ documents, activeDocumentIndex: 0 }); // Reset to the first document when setting new documents
        },
        renameDocument: (doc: IContextDocument, newName: string) => {
            const documents = get().documents;
            const index = documents.indexOf(doc);
            if (index === -1) {
                throw new Error("Document not found in the store");
            }
            documents[index].document.name = newName;
            set({ documents: [...documents] }); // Trigger update
        },

    })
);
